const state = {
  list: []
};

const getters = {
};

const actions = {
};

const mutations = {
  setNetworks: (state, data) => (state.list = data),
  setNetwork: (state, data, index) => (state.list[index] = data)
};

export default {
  state,
  getters,
  actions,
  mutations
};
